import React from 'react';

export interface PaginatedListFooterProps {
  visibleCount: number;
  totalCount: number;
  hasMore: boolean;
  onShowMore: () => void;
  itemLabel?: string;
}

const PaginatedListFooter: React.FC<PaginatedListFooterProps> = ({
  visibleCount,
  totalCount,
  hasMore,
  onShowMore,
  itemLabel = 'items',
}) => {
  if (totalCount === 0) {
    return null;
  }

  return (
    <div
      className="flex flex-wrap items-center justify-between gap-3 border-t border-secondary-800 pt-4"
      data-testid="paginated-list-footer"
    >
      <p className="text-sm text-secondary-400">
        Showing {visibleCount} of {totalCount} {itemLabel}
      </p>
      {hasMore ? (
        <button type="button" className="btn-secondary text-sm" onClick={onShowMore}>
          Show more
        </button>
      ) : null}
    </div>
  );
};

export default PaginatedListFooter;
